'use client';

import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';

import { useOverlay } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import PasskeyIcon from '@flipster/react/icon/generated/PasskeyIcon';
import { css } from '@flipster/styled-system/css';

const RegisterMfaGuide = ({ onClose }: { onClose: () => void }) => {
  const t = useTranslations();
  const router = useRouter();
  const overlay = useOverlay();

  return (
    <>
      <Modal.Content>
        <div className={css({ textAlign: 'center' })}>
          <PasskeyIcon size={80} className={css({ color: 'content.accent.info', textAlign: 'center' })} />
        </div>
        <p>{t('Mfa_verify.r250912.Identity_verification_register_description')}</p>
      </Modal.Content>
      <Modal.Footer>
        <Button
          label={t('Mfa_verify.r250915.Register')}
          size='large'
          onClick={() => {
            onClose();
            overlay.closeSlot();
            router.push('/user/account');
          }}
        />
      </Modal.Footer>
    </>
  );
};

export default RegisterMfaGuide;
